export const API_KEY_GOOGLE = 'AIzaSyBWj-z1916MmpcimZW3xPlRGXMikForpS4'
export const GOOGLE_RECAPTCHA_SITE_KEY =
	'6LfRbt4aAAAAAHs-U2JiVMN3ZtJGNqfo3IRplEHP'
export const API_KEY_COINAPI = 'BF007ED1-B7C5-4B66-9144-FB853269CB58'
